import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_HEALTHDISTRICTS_LOAD,
    ACTION_HEALTHDISTRICTS_LOAD_BY_ID,

    ACTION_HEALTHDISTRICTS_SAVE,

    ACTION_HEALTHDISTRICTS_CREATE,

    ACTION_HEALTHDISTRICTS_VALIDATE,

    IHealthDistrictLoadAction,
    IHealthDistrictLoadByIdAction,
    IHealthDistrictLoadFailureAction,
    IHealthDistrictLoadSuccessAction,

    IHealthDistrictSaveAction,
    IHealthDistrictSaveSuccessAction,
    IHealthDistrictSaveFailureAction,

    IHealthDistrictCreateAction,
    IHealthDistrictCreateSuccessAction,
    IHealthDistrictCreateFailureAction,

    IHealthDistrictValidateAction,
    IHealthDistrictValidateSuccessAction,
    IHealthDistrictValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/healthDistrict";
import { healthDistrictsApi } from 'src/services/healthDistricts';

export const
    getHealthDistrictsEpic = (action$): Observable<IHealthDistrictLoadSuccessAction | IHealthDistrictLoadFailureAction> => {
        return action$
            .ofType(ACTION_HEALTHDISTRICTS_LOAD)
            .mergeMap((_action: IHealthDistrictLoadAction) => {
                return healthDistrictsApi
                    .getHealthDistricts()
                    .map(response =>
                        LoadSuccess(response.healthDistricts, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getHealthDistrictsByIdEpic = (action$): Observable<IHealthDistrictLoadSuccessAction | IHealthDistrictLoadFailureAction> => {
        return action$
            .ofType(ACTION_HEALTHDISTRICTS_LOAD_BY_ID)
            .mergeMap((action: IHealthDistrictLoadByIdAction) => {
                return healthDistrictsApi
                    .getHealthDistrictById(action.id)
                    .map(response =>
                        LoadSuccess(response.healthDistrict, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setHealthDistrictEpic = (action$): Observable<IHealthDistrictSaveSuccessAction | IHealthDistrictSaveFailureAction> => {
        return action$
            .ofType(ACTION_HEALTHDISTRICTS_SAVE)
            .mergeMap((action: IHealthDistrictSaveAction) => {
                return healthDistrictsApi
                    .setHealthDistrict(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.healthDistrict, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createHealthDistrictEpic = (action$): Observable<IHealthDistrictCreateSuccessAction | IHealthDistrictCreateFailureAction> => {
        return action$
            .ofType(ACTION_HEALTHDISTRICTS_CREATE)
            .mergeMap((_action: IHealthDistrictCreateAction) => {
                return healthDistrictsApi
                    .createHealthDistrict()
                    .map(response =>
                        CreateSuccess(response.healthDistrict, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateHealthDistrictEpic = (action$): Observable<IHealthDistrictValidateSuccessAction | IHealthDistrictValidateFailureAction> => {
        return action$
            .ofType(ACTION_HEALTHDISTRICTS_VALIDATE)
            .mergeMap((action: IHealthDistrictValidateAction) => {
                return healthDistrictsApi
                    .validateHealthDistrict(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.healthDistrict, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }